import styled from 'styled-components';

export const LoadingHolder = styled.div`
  width: max-content;
  height: 100px;
  margin: 0 auto;
`;
